// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"c1bfa9ee","24":"bca95c27","41":"086c2ade","322":"73f7e7ba","375":"d23a61e2","622":"e56f55e5","626":"278accc6"}[chunkId] + ".chunk.js";
};